<template>
  <div class="gird">
    <div class="top-title"><span class="i-left"></span>基础信息</div>
    <div class="i-content">
      <base-form
        v-model="baseData"
        :options="baseDataOptions"
        ref="baseData"
        @input="handleChangeBaseData"
        label-width="105px"
      ></base-form>
    </div>
    <div class="i-button">
      <vxe-button size="medium" type="primary" class="vxe-btn-save" @click="save()">
        <svg-icon
          class="icon-img"
          style="font-size: 16px; padding-right: 6px"
          icon-class="icon-preserve"
        />
        {{ $t('credit.btnList.save') }}
      </vxe-button>
    </div>
  </div>
</template>

<script>
  import baseForm from '@/components/form/base-form';
  import { mapState } from 'vuex';
  export default {
    name: 'approvalConfigAdd',
    components: {
      baseForm,
    },
    data() {
      return {
        baseData: {
          billType: null,
          operateType: null,
          priority: 0,
          enable: null,
          validDate: null,
          invalidDate: null,
          titleTemplate:
            '${sendUserName}已在${sendTime}${operateTypeName}${billTypeName}${businessNo}，请查阅！',
        },
        operateTypeList: [],
        billTypeList: [],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      baseDataOptions() {
        return [
          {
            type: 'select',
            label: '单据类型',
            prop: 'billType',
            options: this.billTypeList,
            required: true,
          },
          {
            type: 'select',
            label: '操作类型',
            prop: 'operateType',
            options: this.operateTypeList,
            required: true,
            disabled: this.baseData?.billType ? false : true,
          },
          {
            type: 'inputNumber',
            label: '优先级',
            prop: 'priority',
            min: 0,
            required: true,
          },
          {
            type: 'select',
            label: '是否启用',
            prop: 'enable',
            options: [
              { label: '是', value: 1 },
              { label: '否', value: 0 },
            ],
            required: true,
          },
          {
            type: 'date',
            label: '生效日期',
            prop: 'validDate',
            required: true,
          },
          {
            type: 'date',
            label: '失效日期',
            prop: 'invalidDate',
            required: true,
          },
          {
            label: '标题模板',
            prop: 'titleTemplate',
            type: 'textarea',
            required: true,
          },
        ];
      },
    },
    mounted() {
      this.loadList();
      if (this.$route.query?.id) {
        this.loadData();
      }
    },
    methods: {
      loadData() {
        this.$axios
          .post('/component/approvalTitleConfig/queryById', { id: this.$route.query.id })
          .then((res) => {
            this.baseData = res.data.data;
          })
          .catch((err) => {
            this.$message({
              showClose: true,
              message: err.data.msg,
              type: 'error',
            });
          });
      },
      save() {
        this.$refs.baseData
          .handleSubmit()
          .then(() => {
            this.$axios.post('/component/approvalTitleConfig/save', this.baseData).then((res) => {
              this.dblclickEvent();
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'success',
              });
            });
          })
          .catch((err) => {
            this.$message({
              showClose: true,
              message: err.data.msg,
              type: 'error',
            });
          });
      },
      dblclickEvent() {
        let path = {
          fromPath: {
            path: this.$route.query?.id
              ? '/todoCenter/titleConfigEdit'
              : '/todoCenter/titleConfigAdd',
            name: this.$route.query?.id ? 'titleConfigEdit' : 'titleConfigAdd',
            meta: {
              keepAlive: true,
              title: this.$route.query?.id ? '标题配置编辑' : '标题配置新增',
            },
          },
          toPath: {
            path: '/todoCenter/titleConfig',
            name: 'titleConfig',
            meta: {
              keepAlive: false,
              title: '标题配置',
            },
            query: {},
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      loadList() {
        this.loading.startLoading();
        this.$axios
          .post('/component/approvalBillType/getSelectData')
          .then((res) => {
            this.billTypeList = res.data.data;
            this.loading.endLoading();
          })
          .catch((err) => {
            this.$message({
              showClose: true,
              message: err.data.msg,
              type: 'error',
            });
          });
      },
      loadOperateType(type) {
        this.$axios
          .post('/component/approvalOperateType/getSelectData', { billType: type })
          .then((res) => {
            this.operateTypeList = res.data.data;
          })
          .catch((err) => {
            this.$message({
              showClose: true,
              message: err.data.msg,
              type: 'error',
            });
          });
      },
      handleChangeBaseData(value, prop) {
        if (prop === 'billType') {
          this.loadOperateType(this.baseData.billType);
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  .gird {
    margin-top: 10px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 17px 0px rgba(72, 89, 102, 0.16);
    border-radius: 3px;
  }
  .top-title {
    font-size: 14px;
    border-bottom: 1px solid #ebeef5;
    padding: 15px 20px 15px 20px;
    .i-left {
      display: inline-block;
      margin-right: 10px;
      width: 4px;
      height: 15px;
      background-color: #409eff !important;
      border-radius: 4px;
    }
  }
  .i-content {
    padding: 12px 20px 20px 20px;
  }
  .i-button {
    text-align: center;
    padding-bottom: 20px;
  }
</style>
